/**
 * Kelompokkan kategori per tingkat event (mis. Open / Prestasi / Khusus Kota Bogor)
 * dan urutkan nomornya sama di setiap kelompok:
 * Tanding, Tunggal, Ganda, Regu, Solo Kreatif; di dalam nomor: Tangan Kosong, Senjata, Full.
 *
 * Dipakai bagian Biaya Pendaftaran dan Informasi Kegiatan supaya urutannya selalu sama.
 *
 * @param {Array} daftar   kategori, masing-masing punya `name`
 * @param {Object} label   turnamen.label_tingkat (boleh kosong)
 * @returns {Array<{judul: string, isi: Array}>} isi diberi `nama` tanpa akhiran tingkat
 */
export function kelompokkanPerTingkat(daftar, label = {}) {
  label = label || {};
  const urutan = [label.Pemasalan || 'Pemasalan', label.Prestasi || 'Prestasi', label.Khusus || label.Invitasi || 'Invitasi'];
  const calon = [...new Set([...urutan, 'Pemasalan', 'Prestasi', 'Invitasi', 'Open'])].sort((a, b) => b.length - a.length);
  const grup = new Map();

  for (const k of daftar || []) {
    const nama = String(k?.name || '').trim();
    if (!nama) continue;
    const t = calon.find((c) => nama.toLowerCase().endsWith(' ' + c.toLowerCase()));
    const judul = t || 'Lainnya';
    const tampil = t ? nama.slice(0, nama.length - t.length).trim() : nama;
    if (!grup.has(judul)) grup.set(judul, []);
    grup.get(judul).push({ ...k, nama: tampil || nama });
  }

  const NOMOR = ['tanding', 'tunggal', 'ganda', 'regu', 'solo kreatif'];
  const VARIAN = ['tangan kosong', 'senjata', 'bersenjata', 'full', 'bebas'];
  const rank = (nama) => {
    const n = nama.toLowerCase();
    let a = NOMOR.findIndex((x) => n.startsWith(x));
    if (a === -1) a = 99;
    const b = VARIAN.findIndex((x) => n.includes(x));
    return a * 100 + b;
  };
  const pos = (j) => {
    const i = urutan.indexOf(j);
    return i === -1 ? 99 : i;
  };

  return [...grup.entries()]
    .sort((a, b) => pos(a[0]) - pos(b[0]))
    .map(([judul, isi]) => ({
      judul,
      isi: [...isi].sort((x, y) => rank(x.nama) - rank(y.nama) || x.nama.localeCompare(y.nama)),
    }));
}
